
















import { Component, Prop, Vue } from 'vue-property-decorator';
import settings from '@/AppSettings';

@Component({
	name: 'SidebarLogo'
})
/** docs */
export default class extends Vue {
	@Prop({ required: true }) private collapse!: boolean;

	/** document hooks */
	private title: any = settings.title;
}
